export default __webpack_public_path__ + "img/8b4e07230460fbee8c5c89881a9b9de8.svg";